export default __webpack_public_path__ + "static/4-61532d58f518ce19db8d88a1d8846549.jpeg";